module.exports = {
  FichasData: () => {
    return{
      "avatr7": {
        "url_video" : "https://www.youtube.com/watch?v=eT683CW2PP4",
        "url_catalog" : "https://www.avatr.com/en/configuration?car=07",
        "url_cotiza" : "https://www.avatr.com/en/07",
      },
      "avatr11": {
        "url_video" : "https://www.youtube.com/watch?v=eT683CW2PP4",
        "url_catalog" : "https://www.avatr.com/en/configuration?car=07",
        "url_cotiza" : "https://www.avatr.com/en/07",
      },
      // "001_flagship_awd": {
      //   "url_video" : "https://www.youtube.com/watch?v=IEYOfUxtYP4",
      //   "url_catalog" : "https://qrco.de/bfMTut",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-001/",
      // },

      // "7x_sport_rwd": {
      //   "url_video" : "https://www.youtube.com/watch?v=C_AELwzgr38",
      //   "url_catalog" : "https://zeekrco.com/wp-content/uploads/2025/06/FT-ZEEKR-7X-2026.pdf",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-7x/",
      // },
      // "7x_flagship_aws": {
      //   "url_video" : "https://www.youtube.com/watch?v=C_AELwzgr38",
      //   "url_catalog" : "https://zeekrco.com/wp-content/uploads/2025/06/FT-ZEEKR-7X-2026.pdf",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-7x/",
      // },
      // "7x_premium_rwd": {
      //   "url_video" : "https://www.youtube.com/watch?v=C_AELwzgr38",
      //   "url_catalog" : "https://zeekrco.com/wp-content/uploads/2025/06/FT-ZEEKR-7X-2026.pdf",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-7x/",
      // },

      // "x_sport_rwd": {
      //   "url_video" : "https://www.youtube.com/watch?v=PnDAAf07Wrg",
      //   "url_catalog" : "https://qrco.de/bfMTqS",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-x/",
      // },
      // "x_flagship_aws": {
      //   "url_video" : "https://www.youtube.com/watch?v=PnDAAf07Wrg",
      //   "url_catalog" : "https://qrco.de/bfMTqS",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-x/",
      // },
      // "x_premium_rwd": {
      //   "url_video" : "https://www.youtube.com/watch?v=PnDAAf07Wrg",
      //   "url_catalog" : "https://qrco.de/bfMTqS",
      //   "url_cotiza" : "https://zeekrco.com/zeekr-x/",
      // },
    }
  }
}